/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const RightArrowIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="28"
      viewBox="0 0 16 28"
      fill="none"
    >
      <path
        d="M9.81218 14.0588L0.744837 23.4667C0.267774 23.9646 2.56712e-06 24.6382 2.6285e-06 25.3403C2.68988e-06 26.0424 0.267774 26.716 0.744838 27.2139C0.982952 27.463 1.26625 27.6607 1.57838 27.7956C1.89051 27.9305 2.22529 28 2.56343 28C2.90156 28 3.23635 27.9305 3.54848 27.7956C3.86061 27.6607 4.14391 27.463 4.38202 27.2139L15.2423 15.9457C15.4824 15.6986 15.673 15.4047 15.803 15.0808C15.933 14.757 16 14.4096 16 14.0588C16 13.7079 15.933 13.3606 15.803 13.0367C15.673 12.7129 15.4824 12.4189 15.2423 12.1719L4.38202 0.770751C4.14268 0.524442 3.85884 0.329574 3.54676 0.197318C3.23469 0.0650646 2.90052 -0.00197678 2.56343 4.50437e-05C2.22633 -0.00197672 1.89216 0.0650647 1.58009 0.197318C1.26802 0.329574 0.984172 0.524442 0.744835 0.770751C0.267772 1.26869 5.82983e-07 1.94226 6.44362e-07 2.64436C7.05742e-07 3.34646 0.267772 4.02003 0.744836 4.51797L9.81218 14.0588Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
